module.exports = __webpack_public_path__ + "img/dots.89771dfd.svg";